import React from "react";

type UserProfileProps = {
  userName?: string;
  onSignOff: () => void;
  loadingEmployee: boolean;
};

const UserProfile: React.FC<UserProfileProps> = React.memo(
  ({ userName = "User", onSignOff, loadingEmployee = false }) => {
    return (
      <div className="font-gotham5r flex justify-center items-center gap-4">
        {!loadingEmployee && userName && (
          <span className="mr-2 text-white truncate">Welcome, {userName}</span>
        )}
        <button
          type="button"
          className="flex items-center py-0! button -primary -light -dark -right"
          onClick={onSignOff}
        >
          Sign Off
        </button>
      </div>
    );
  },
);
UserProfile.displayName = "UserProfile";

export default UserProfile;
